import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IProfileService } from "App/Modules/Auth";
import type { IResponseWithLoading, ISite } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService, IPageService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class DesignAndPlanningComponentController {
    public static $inject: string[] = [
        "$scope",
        "irPageService",
        "mmSitesRepository",
        "mmModalService",
        "mmProfileService",
    ];

    public siteId: string;

    public site: IResponseWithLoading<ISite>;

    constructor(
        private readonly $scope: IScope,
        private readonly pageService: IPageService,
        private readonly sitesRepository: ISitesRepository,
        private readonly modalService: IModalService,
        private readonly profileService: IProfileService,
    ) {}

    public $onInit() {
        this.site = { isLoading: true };
        extendWithLoadingAndFail(this.sitesRepository.getSite(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<ISite>) => {
                    if (!response.hasError && response.data) {
                        this.site = response;
                    }
                },
                (error) => {
                    this.site = error;
                },
            );
    }
}
